<script>
  export let stores = [];
  export let clientType = 'particulier';
  
  // Fonction de tri par distance
  function sortByDistance(a, b) {
    if (a.distance === undefined && b.distance === undefined) return 0;
    if (a.distance === undefined) return 1;
    if (b.distance === undefined) return -1;
    return a.distance - b.distance;
  }
  
  // Trier les magasins par distance s'ils ont une propriété distance
  $: sortedStores = [...stores].sort(sortByDistance);
</script>

<div class="stores-list">
  {#each sortedStores as store (store.id)}
    <div class="store-card {clientType === 'professionnel' ? 'professional' : ''}">
      <h3 class="store-name">{store.name}</h3>
      <div class="store-address">
        {store.address}<br>
        {store.zipCode} {store.city}
      </div>
      
      {#if store.distance !== undefined}
        <div class="store-distance">
          <span class="distance-icon">📍</span> {store.distance.toFixed(1)} km
        </div>
      {/if}
      
      {#if clientType === 'professionnel' && store.proServices}
        <div class="pro-services">
          <h4>Services professionnels:</h4>
          <ul>
            {#each store.proServices as service}
              <li>{service}</li>
            {/each}
          </ul>
        </div>
      {/if}
      
      <!-- <div class="store-actions">
        <a 
          href={`https://www.google.com/maps/dir/?api=1&destination=${store.lat},${store.lng}`} 
          target="_blank" 
          class="action-button"
        >
          Itinéraire
        </a>
      </div> -->
    </div>
  {/each}
</div>

<style>
  .stores-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  @media only screen and (max-width: 768px) {
    .stores-list {
        max-height: 40vh;
      }
  }
  .store-card {
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .store-card.professional {
    border-left: 4px solid #0056b3;
  }
  
  .store-name {
    margin-top: 0;
    margin-bottom: 10px;
    font-size: 18px;
    color: #333;
  }
  
  .store-address {
    margin-bottom: 10px;
    color: #666;
    line-height: 1.4;
  }
  
  .store-distance {
    margin-bottom: 15px;
    font-size: 14px;
    font-weight: bold;
    color: #4285F4;
  }
  
  .distance-icon {
    font-size: 16px;
    margin-right: 5px;
  }
  
  .pro-services {
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f7f9fc;
    border-radius: 4px;
  }
  
  .pro-services h4 {
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 14px;
    color: #0056b3;
  }
  
  .pro-services ul {
    margin: 0;
    padding-left: 20px;
  }
  
  .pro-services li {
    font-size: 13px;
    margin-bottom: 4px;
  }
  
  .store-actions {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  
  .action-button {
    padding: 8px 12px;
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    text-decoration: none;
    color: #333;
    display: inline-block;
  }
  
  .action-button:hover {
    background-color: #e0e0e0;
  }
  
  .action-button.pro-contact {
    background-color: #0056b3;
    color: white;
    border-color: #0056b3;
  }
  
  .action-button.pro-contact:hover {
    background-color: #004494;
  }
</style>